import { render, staticRenderFns } from "./ecollectionlogs.vue?vue&type=template&id=7786e26e&"
import script from "./ecollectionlogs.vue?vue&type=script&lang=js&"
export * from "./ecollectionlogs.vue?vue&type=script&lang=js&"
import style0 from "./ecollectionlogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports